<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent1">I’d like to start by thanking my husband, Ravi, for all the support while I’ve been writing. For every author talk I had for <i>Murder &amp; Mayhem in Dayton and the Miami Valley</i>, you were there to encourage me, to be a familiar face in the crowd and to give me honest feedback. Ravi, you’re my number one person, and I am so grateful to have you in my life.</p>
<p class="indent">To Tim Sikora and Randy “Diva” Lake, I thank you both for helping me get a better understanding of the aircrafts I’ve mentioned in the Wright-Patterson chapter. Without your help, that chapter would have been much shorter and less informative.</p>
<p class="indent">Thank you to Martha Ballinger from Dayton Metro Library, who has helped me schedule author talks and with research for Dayton Unknown for years. Thank you to Kris Lininger from Wright Library, for suggesting the subject for a presentation, which led to this book. Librarians are the best!</p>
<p class="indent">Thank you to my friends and family on Facebook who shared stories and weighed in on the type of stories you wanted to read. Thank you also for all the support you’ve given with author talks and publicity.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?bcf73ab2